import { MuiThemeProvider, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import React from 'react';
import { Redirect } from 'react-router-dom';
import { Permissions } from '../../../shared/auth/constants/permissions';
import { useHasPermission } from '../../Session';
import BasicLayout from '../../layouts/BasicLayout';
import basicTheme from '../../layouts/BasicLayout/basicTheme';
import CreateSaleTransaction from '../../pages/SaleTransactions/CreateSaleTransaction';

const CreateSaleTransactionRoute = () => {
    const canCreate = useHasPermission(Permissions.SALES_TRANSACTION_CREATE);
    const theme = useTheme();

    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

    if (canCreate) {
        if (isSmall) {
            return (
                <MuiThemeProvider theme={basicTheme}>
                    <CreateSaleTransaction />
                </MuiThemeProvider>
            );
        }

        return (
            <BasicLayout disabledPadding>
                <CreateSaleTransaction />
            </BasicLayout>
        );
    }

    return <Redirect to="/403" />;
};

export default CreateSaleTransactionRoute;
